import { Component, Input, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadApiService } from 'src/app/services/uploadapi.service';
import { saveAs } from 'file-saver';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'app-download-tree-node',
    templateUrl: './download-tree-node.component.html',
    styleUrls: ['./download-tree-node.component.scss'],
})
export class DownloadTreeNodeComponent {
    @Input() menuData: any;
    @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
    @ViewChild(MatMenuTrigger) childTrigger!: MatMenuTrigger;
    @ViewChild(MatMenuTrigger) subChildTrigger!: MatMenuTrigger;
    @ViewChild(MatMenuTrigger) lastmenuTrigger!: MatMenuTrigger;

    tooltip_position = 'above';
    selectedOptions: string[] = [];
    taggedItemselectedOptions: string[] = [];
    selectedItems: any[] = [];
    selectedTaggedItems: any[] = [];
    selectedData: any;

    constructor(
        private uploadApiService: UploadApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private customToastService: CustomToastService
    ) {}

    ngOnInit(): void {}

    onMenuClosed(event: any, data: any, menuLevel: string) {
        //To Keep menu open for checkbox list
        if (data.some((item) => item.menuType === 2)) {
            if (menuLevel == 'menuTrigger') {
                this.menuTrigger.openMenu();
            }
            if (menuLevel == 'childTrigger') {
                this.childTrigger.openMenu();
            }
            if (menuLevel == 'subChildTrigger') {
                this.subChildTrigger.openMenu();
            }
            if (menuLevel == 'lastmenuTrigger') {
                this.lastmenuTrigger.openMenu();
            }
        } else {
            //To Keep menu close for checkbox list
            this.menuTrigger.closeMenu();
        }
    }

    onSelectionChange(selectionList: MatSelectionList) {
        this.selectedItems = selectionList.selectedOptions.selected.map((option) => option.value);
    }

    onTaggedItemSelectionChange(selectionList: MatSelectionList) {
        this.selectedTaggedItems = selectionList.selectedOptions.selected.map((option) => option.value);
    }

    DownloadTemplate(Type: string, data?: any, viewId?: string, prevItem?: any) {
        this.ngxUiLoaderService.start();
        let params = {};
        let fileName = '';
        if (Type == 'TaggedItems') {
            if (this.selectedData) {
                params = {
                    uploadType: 'TaggedItem',
                    typeId: this.selectedData?.id,
                    calculationTypes: this.selectedTaggedItems,
                    viewId: viewId,
                };
                fileName = this.selectedData?.name + ' Import Template.xlsx';
            } else {
                params = {
                    uploadType: 'TaggedItem',
                    typeId: data?.id,
                    viewId: viewId,
                };
                fileName = data?.name + ' Import Template.xlsx';
            }
        } else if (Type == 'PipeSpecifications') {
            params = {
                uploadType: 'PipeSpec',
                calculationTypes: this.selectedItems,
            };
            fileName = 'Pipe Spec Import Template.xlsx';
        } else if (Type == 'ActivityPacks') {
            params = {
                uploadType: data?.index,
                typeId: viewId,
            };
            fileName = 'Activity Pack Import Template.xlsx';
        } else if (Type == 'Projects') {
            params = {
                uploadType: prevItem?.index,
                typeId: viewId,
            };
            fileName = data?.name + ' Project Import Template.xlsx';
        } else if (Type == 'Documents') {
            params = {
                uploadType: data?.index,
                viewId: viewId,
            };
            fileName = prevItem?.name + ' Document Import Template.xlsx';
        }
        this.uploadApiService.downloadTemplate(params).subscribe(
            (response: any) => {
                if (response.success) {
                    const safeFileName = (fileName || 'downloaded-file').replace(/[^a-zA-Z0-9_\-.]/g, '_');

                    let byteArray: Uint8Array;
                    try {
                        const byteCharacters = atob(response.response); // base64 decode
                        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        byteArray = new Uint8Array(byteNumbers);
                    } catch (e) {
                        console.error('Invalid base64 content', e);
                        return;
                    }

                    const blob = new Blob([byteArray], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = safeFileName;
                    link.click();
                    // const url = URL.createObjectURL(blob);

                    // const link = document.createElement('a');
                    // Object.defineProperty(link, 'href', { value: url, writable: false });
                    // Object.defineProperty(link, 'download', { value: safeFileName, writable: false });
                    // link.style.display = 'none';

                    // document.body.appendChild(link);
                    // link.click();
                    // document.body.removeChild(link);
                    // URL.revokeObjectURL(url);

                    this.ngxUiLoaderService.stop();
                } else {
                    this.customToastService.errorToast(response.message, 'Error');
                    this.ngxUiLoaderService.stop();
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
                this.customToastService.errorToast("Something went wrong , Please try again or contact administrator'", 'Error');
            }
        );
    }

    onHover(event: MouseEvent, item?: any, selectionList?: MatSelectionList, taggedItemselectionList?: MatSelectionList) {
        this.selectedData = item;
        if (selectionList) selectionList.deselectAll();
        if (taggedItemselectionList) taggedItemselectionList.deselectAll();
        this.selectedItems = [];
        this.selectedTaggedItems = [];
        this.selectedOptions = [];
        this.taggedItemselectedOptions = [];
    }

    getMenuId(item: any): string {
        return (item?.index !== undefined ? `menu${item.index}` : `menu${item.id}`) + item.name.replace(/\s+/g, '');
    }

    IsCheckList(data: any) {
        if (data?.children?.length) {
            const filteredItems = data?.children.filter((item) => item.menuType === 2);
            return filteredItems.length > 0;
        } else return false;
    }

    removeSpace(value: string) {
        return value.replace(/\s+/g, '');
    }
}
